import { ManualRestoreModel, ManualRestoreRequest } from '@logz-pkg/models';
import { CrudApiService } from '../utilities/crud.api.service';

export class ManualRestoreApiService {
  crudApiService = new CrudApiService<ManualRestoreModel, ManualRestoreRequest>({ modelDefinition: ManualRestoreModel });

  urls = {
    collection: '/restore-accounts',
  };

  create = async (model: ManualRestoreRequest): Promise<ManualRestoreModel> =>
    this.crudApiService.create(this.urls.collection, model);

  getAll = async (): Promise<ManualRestoreModel[]> => this.crudApiService.getAll(this.urls.collection);
}

export const manualRestoreApiService = new ManualRestoreApiService();
